<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="500px")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
          slot="activator" 
          small 
          class='mr-2' 
          title='Approval' 
          color="blue" 
          v-bind="attrs"
          v-on="on"
          :id="'loginActionApprovalMemo_' + imItems.imNo"
        ) assignment_turned_in

    v-card()
      v-card-title(class="headline grey lighten-3 mb-3") Approval Form
      v-card-text
        v-layout(wrap)
          v-flex(xs12)
            h1 
            //- v-radio-group(id="loginAppvDialogStatusRadioGroup" v-model="approval" row)
            //-   v-radio(id="loginAppvDialogApprove" v-if="imItems.imStatus != 3" label="Approve" color="success" value="7")
            //-   v-radio(id="loginAppvDialogReject" v-if="imItems.imStatus != 3" label="Reject" color="red" value="8")
            //-   v-radio(id="loginAppvDialogReview" label="Need Review" color="yellow darken-4" value="3")
            //- div(v-if="approval == 3" style="color:#000000;" class="mb-2") Please select the user to revise/review the memo. Approver will start from the selected user.
          //- v-flex(v-if="approval == 3" xs12)
          //-   v-select(
          //-     id="loginAppvDialogReviewerDropdown"
          //-     v-model="select"
          //-     :hint="jabatan"
          //-     :items="reviewer"
          //-     item-text="alias"
          //-     item-value="id"
          //-     label="Select"
          //-     persistent-hint
          //-     return-object
          //-     single-line
          //-     v-if="imItems.imUseAlias"
          //-     dense)
          //-   v-select(
          //-     id="loginAppvDialogReviewerDropdown"
          //-     v-model="select"
          //-     :hint="jabatan"
          //-     :items="reviewer"
          //-     item-text="name"
          //-     item-value="id"
          //-     label="Select"
          //-     persistent-hint
          //-     return-object
          //-     single-line
          //-     v-else
          //-     dense)
          v-flex(xs12)
            //- v-textarea(
            //-   id="loginAppvDialogCommentBox"
            //-   class="mt-3"
            //-   v-model="comment"
            //-   filled
            //-   label="Comment (Optional)"
            //-   counter="150"
            //-   :rules="[rules.length(150)]"
            //- )
            div(style="display: flex; align-items: left; height: 80px; width: 100%; border: 1px solid #ccc; padding: 20px; text-align: left; position: relative;")
              img(src="/img/icons/warning.png" width="50px" style="margin-right:1vw")
              p(style="font-size: 16px; color:black") For approval, please use the link provided in the email or WhatsApp message. Thank you

            
      v-card-actions.pb-5
        v-spacer
        v-btn(
          id="loginAppvDialogClose"
          depressed
          @click="dialog = false"
          class="pl-4 pr-4"
        )
          | Close

        //- v-btn(
        //-   :disabled="approval == null || !select.hasOwnProperty('id') && approval == 3 || comment != null && comment.length > 150" 
        //-   color="blue-secondary" 
        //-   depressed 
        //-   id="loginAppvDialogSubmit"
        //-   @click="submit"
        //-   class="pl-4 pr-4"
        //-   :loading="btnLoader"
        //- ) Submit

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
export default {
  name: 'ApprovalDialog',
  props: {
    imItems: Object
  },
  data: () => ({
    dialog: false,
    approval: null,
    comment: null,
    select: {},
    overlay: false,
    rules: {
        length: len => v => (v || '').length <= len || `Comment must be less than 150 characters`,
      },
    btnLoader: false
  }),
  computed: {
    ...mapState(["API_URL","WE_URL","dataUsers"]),
    reviewer: function() {
      let result = [];
      result.push(this.imItems.imUser);
      for (const wf of this.imItems.imWorkflow) {
        if (wf.status == 9 || wf.status == 3)  break;
        result.push(wf);
      }
      return result;
    },
    jabatan: function() {
      if(this.select === this.imItems.imUser){
        return this.select.position + ' (Initiator)';
      }
      return this.select.position;
    }
  },
  methods: {
    submit() {
      this.btnLoader = true;
      this.overlay = true
      let token = localStorage.getItem("token");
      let person = ''
      let find = this.imItems.imStatus == 3 ? 3 : 9
      for(let i in this.imItems.imWorkflow) {
        if (this.imItems.imWorkflow[i].status == find) person = this.imItems.imWorkflow[i]
      }
      let config = {
        method: "put",
        url: process.env.VUE_APP_API_OLD+ `/api/v2/update/requests/${this.$store.state.dataUsers.user._id}`,
        headers: {"Authorization": `Bearer ${token}`},
        data: {
          _id: this.imItems._id, 
          status: parseInt(this.approval), 
          comment: this.comment,
          person,
          backto: parseInt(this.approval) == 3 ? this.select : null
        }
      };
      axios(config)
        .then(res => {
         
          this.overlay = false;
          if (res.status == 200) {
            this.dialog = false;
            this.$toasted.success(res.data.message, { icon : 'check_circle'});
            location.reload();
          }
        }).catch(err => {
          if (err.response.status == 500) {
            this.dialog = false;
            this.$toasted.error(err.response.data.message+", please reload your page", { icon : 'error'});
             this.overlay = false;
          }else{
            this.overlay = false;
            this.$toasted.error(err.response.data.error, { icon : 'error'})
          }  
        }).finally(() => {
            this.btnLoader = false;
        });
    }
  }
};
</script>

<style scoped>
  .tgLbl {
    position: relative;
    margin: 0 30px 0 10px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
